import { Divider, Typography } from "@material-ui/core";
import {
  LoyaltyInfoFormComponentProps,
  TravelerSelectDropdown,
  TravelerSelectStep,
} from "halifax";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { CallState, IPerson, ITravelerStepErrors } from "redmond";
import {
  TRAVELER_SELECT_DROPDOWN_DESCRIPTION,
  TRAVELER_SELECT_DROPDOWN_TITLE,
} from "./constants";
import { DriverSelectDropdownFormConnectorProps } from "./container";
import { HertzLoyaltyForm } from "../../HertzRewardsForm";
import {
  AVAILABLE,
  CORP_EMBEDDED_TRAVELER_FORM_EXPERIMENT,
  getExperimentVariant,
  useExperiments,
} from "../../../../../context/experiments";
import "./styles.scss";

export interface DriverSelectDropdownFormProps
  extends DriverSelectDropdownFormConnectorProps {
  disableEditTravelerInfo: boolean;
  selectedTravelers: IPerson[];
  updateSelectedTravelersList: (traveler: IPerson) => void;
  removeSelectedTraveler: (traveler: IPerson) => void;
  setProgress: (progress: TravelerSelectStep) => void;
  showErrors: ITravelerStepErrors;
  setShowErrors: (showErrors: ITravelerStepErrors) => void;
  isMissingLicense?: boolean;
}

export const DriverSelectDropdownForm = ({
  travelers,
  disableEditTravelerInfo,
  selectedTravelers,
  updateSelectedTravelersList,
  updateUserPassenger,
  setProgress,
  removeSelectedTraveler,
  showErrors,
  setShowErrors,
  userPassengerCallState,
  isMissingLicense,
  isHertzProvider,
  selectedVehicle,
  userRoles,
}: DriverSelectDropdownFormProps) => {
  const [dropdownCount, setDropdownCount] = useState(
    selectedTravelers.length || 1
  );

  const expState = useExperiments();
  const useEmbeddedTravelerForm =
    getExperimentVariant(
      expState.experiments,
      CORP_EMBEDDED_TRAVELER_FORM_EXPERIMENT
    ) === AVAILABLE;

  useEffect(() => {
    if (disableEditTravelerInfo) {
      setDropdownCount(selectedTravelers.length);
    }
  }, [disableEditTravelerInfo]);

  const vendorCode = selectedVehicle?.supplierRef;

  const renderLoyaltyComponent = useCallback(
    ({ disabled }: LoyaltyInfoFormComponentProps) => (
      <HertzLoyaltyForm
        disabled={disabled}
        showErrors={showErrors}
        setShowErrors={setShowErrors}
      />
    ),
    [showErrors, setShowErrors]
  );

  return (
    <div className="cars-traveler-select-dropdown-container">
      <div className="form-container">
        <Typography variant="h3" className="title">
          {TRAVELER_SELECT_DROPDOWN_TITLE}
        </Typography>
        <Typography variant="body2" component="p" color="textPrimary">
          {TRAVELER_SELECT_DROPDOWN_DESCRIPTION}
        </Typography>
        {[...Array(dropdownCount)].map((_, index) => (
          <Fragment key={index}>
            {index > 0 && <Divider style={{ margin: "20px 0" }} />}
            <TravelerSelectDropdown
              travelers={travelers}
              showDriverLicenseSection
              disableEditTravelerInfo={disableEditTravelerInfo}
              selectedTravelers={selectedTravelers}
              updateSelectedTraveler={updateSelectedTravelersList}
              removeSelectedTraveler={(traveler) => {
                removeSelectedTraveler(traveler);
                setDropdownCount((prevCount) =>
                  prevCount === 1 ? 1 : prevCount - 1
                );
              }}
              setProgress={setProgress}
              index={index}
              updateUserPassenger={(payload, _) => updateUserPassenger(payload)}
              showErrors={showErrors}
              setShowErrors={setShowErrors}
              loading={userPassengerCallState === CallState.InProcess}
              productType="car"
              loyaltyProgram={null}
              renderLoyaltyComponent={
                isHertzProvider ? renderLoyaltyComponent : undefined
              }
              groundLoyaltyVendorCode={vendorCode}
              isMissingLicense={isMissingLicense}
              useEmbeddedTravelerForm={useEmbeddedTravelerForm}
              userRoles={userRoles}
            />
          </Fragment>
        ))}
      </div>
    </div>
  );
};
